import { api } from '@/lib/api';
import type { PaginatedResponse } from '@/types';

/** Fetch complete lists using the API's maximum supported page size. */
export async function getAllPages<T>(path: string): Promise<T[]> {
  const [pathname, search = ''] = path.split('?');
  const params = new URLSearchParams(search);
  const pageSize = 100;
  params.set('limit', String(pageSize));
  const result: T[] = [];
  for (let page = 1; ; page += 1) {
    params.set('page', String(page));
    const response = await api.get<PaginatedResponse<T>>(`${pathname}?${params.toString()}`);
    if (response.success === false) throw new Error(response.error || 'Daten konnten nicht geladen werden.');
    const batch = response.data ?? [];
    result.push(...batch);
    if (typeof response.total_pages === 'number'
      ? page >= response.total_pages
      : batch.length < pageSize) return result;
  }
}
